import { render } from "./UpdateAvailable.vue?vue&type=template&id=0dc2c886&scoped=true"
import script from "./UpdateAvailable.vue?vue&type=script&lang=js"
export * from "./UpdateAvailable.vue?vue&type=script&lang=js"

import "./UpdateAvailable.vue?vue&type=style&index=0&id=0dc2c886&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Top\\Work\\Impelos\\Repos\\load-manager\\loadSheet\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc2c886"]])

export default __exports__